<template>
    <div class="warpper">
        <div class="box_1 flex-col">
          <div class="p_img">
            <a href="javascript:;">
              <img src="@/assets/client/banner_6.jpg" alt="新闻资讯" title="新闻资讯">
            </a>
          </div>
          <div class="p_info">
            <div>
              <h2 class="text-white p_btitle">新闻资讯</h2>
              <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
            </div>
          </div>
          </div>
          <div class="box_5 flex-col">
            <div class="box_6 flex-row">
              <div class="text-wrapper_1 flex-col justify-between">
                <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;新闻动态</span>
                <span class="text_14">{{modelitemName}}</span>
              </div>
              <div class="box_7 flex-row justify-between">
                <div class="text-wrapper_2 flex-col" @click="setState('NT01')"   :style="{'background-color':form.modelitem=='NT01'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_15" :style="{'color':form.modelitem=='NT01'?'white':'rgba(0, 90, 214, 1)'}">公司动态</span>
                </div>
                <div class="text-wrapper_3 flex-col" @click="setState('NT02')"  :style="{'background-color':form.modelitem=='NT02'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_16"  :style="{'color':form.modelitem=='NT02'?'white':'rgba(0, 90, 214, 1)'}">媒体关注</span>
                </div>
                <div class="text-wrapper_4 flex-col" @click="setState('NT03')" :style="{'background-color':form.modelitem=='NT03'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_17"  :style="{'color':form.modelitem=='NT03'?'white':'rgba(0, 90, 214, 1)'}">行业新闻</span>
                </div>
                <div class="text-wrapper_5 flex-col"  @click="setState('NT04')"  :style="{'background-color':form.modelitem=='NT04'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_18" :style="{'color':form.modelitem=='NT04'?'white':'rgba(0, 90, 214, 1)'}">影像先河</span>
                </div>
              </div>
              <div class="text-wrapper_6_be" >
              <transition  name="slide">
                  <div class="text-wrapper_6 flex-col" v-if="telshow">
                    <span class="text_19">4001-300-137</span>
                  </div>
              </transition>
             </div>
             <div>

             </div>
             <div>

             </div>
             <div class="box_8_1">
              <div class="box_8 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                <div class="image-text_1 flex-col justify-between">
                  <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    src="@/assets/client/tel.png"
                  />
                  <span class="text-group_1">业务咨询</span>
                </div>
              </div>
             </div>
            </div>
            <div class="image-wrapper_1 flex-row">
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="@/assets/client/xwzxbg.png"
              />
            </div>

            <template v-for="(item,index) in loopData0">
              <div class="box_21">
                <div class="box_11 flex-row">
                  <div class="image-text_3 flex-row justify-between" @click="selelctNews(item)">
                    <div class="block_2 flex-col">
                      <img class="image_1" :src="(`${item.viewPath}`)"></img>
                    </div>
                    <div class="text-group_3 flex-col">
                      <div class="text-wrapper_9 flex-row justify-between">
                        <span class="text_23"
                          >{{item.title}}</span
                        >
                        <span class="text_24"
                          >&nbsp;&nbsp;发布时间：{{item.publishdate}}</span
                        >
                      </div>
                      <span class="paragraph_2"
                        >{{item.subtitle}}</span
                      >
                    </div>
                  </div>
                  </div>
                  <div class="image-wrapper_2 flex-row">
                      <img
                      class="image_3"
                      referrerpolicy="no-referrer"
                      src="@/assets/client/underline.png"
                    />
                  </div>
              </div>
            </template>
            <div class="box_18 flex-row">
              <el-pagination ref="mypage" @current-change="handleCurrentChange" :page-sizes="[12]" :page-size="form.pageSize"
                  :current-page="form.pageIndex" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>

          </div>

          <!-- 移动端新闻列表页面 -->
          <div class="mobile-news-container">
            <!-- Banner图 -->
            <div class="mobile-news-banner">
              <img 
                src="@/assets/client/banner_6.jpg" 
                alt="新闻资讯" 
                class="mobile-news-banner__image"
              />
              <div class="mobile-news-banner__overlay"></div>
              <div class="mobile-news-banner__content">
                <h1 class="mobile-news-banner__title">新闻资讯</h1>
                <p class="mobile-news-banner__subtitle">NEWS CENTER</p>
              </div>
            </div>

            <!-- 当前位置 -->
            <div class="mobile-news-breadcrumb">
              <p class="mobile-news-breadcrumb__text">
                当前位置：首页 > 新闻动态 > 
                <span class="mobile-news-breadcrumb__current">{{ modelitemName }}</span>
              </p>
            </div>

            <!-- 子菜单按钮列表 -->
            <div class="mobile-news-submenu">
              <div class="mobile-news-submenu__grid">
                <button
                  :class="['mobile-news-submenu__button', { 'mobile-news-submenu__button--active': form.modelitem === 'NT01' }]"
                  @click="setState('NT01')"
                >
                  公司动态
                </button>
                <button
                  :class="['mobile-news-submenu__button', { 'mobile-news-submenu__button--active': form.modelitem === 'NT02' }]"
                  @click="setState('NT02')"
                >
                  媒体关注
                </button>
                <button
                  :class="['mobile-news-submenu__button', { 'mobile-news-submenu__button--active': form.modelitem === 'NT03' }]"
                  @click="setState('NT03')"
                >
                  行业新闻
                </button>
                <button
                  :class="['mobile-news-submenu__button', { 'mobile-news-submenu__button--active': form.modelitem === 'NT04' }]"
                  @click="setState('NT04')"
                >
                  影像先河
                </button>
              </div>
            </div>

            <!-- 新闻列表 -->
            <div class="mobile-news-list">
              <h2 class="mobile-news-list__title">{{ modelitemName }}</h2>
              
              <div v-if="loopData0.length > 0">
                <div
                  v-for="(item, index) in getMobileDisplayNews()"
                  :key="item.id"
                  class="mobile-news-card"
                  @click="selelctNews(item)"
                >
                  <div class="mobile-news-card__image-wrapper">
                    <img 
                      :src="item.viewPath"
                      :alt="item.title"
                      class="mobile-news-card__image"
                    />
                  </div>
                  <div class="mobile-news-card__content">
                    <h3 class="mobile-news-card__title">{{ item.title }}</h3>
                    <p class="mobile-news-card__subtitle">{{ item.subtitle }}</p>
                    <div class="mobile-news-card__meta">
                      <span class="mobile-news-card__date">
                        <span class="el-icon-time"></span>
                        {{ item.publishdate }}
                      </span>
                      <span class="mobile-news-card__more">
                        <span>查看详情</span>
                        <span class="mobile-news-card__more-icon el-icon-arrow-right"></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 空状态 -->
              <div v-else class="mobile-news-empty">
                <div class="mobile-news-empty__icon">📰</div>
                <p class="mobile-news-empty__text">暂无新闻数据</p>
              </div>
            </div>

            <!-- 查看更多按钮 -->
            <div 
              v-if="hasMoreNews()" 
              class="mobile-news-loadmore"
            >
              <button 
                class="mobile-news-loadmore__button"
                @click="loadMoreNews"
              >
                <span>查看更多</span>
                <span class="mobile-news-loadmore__icon el-icon-arrow-down"></span>
              </button>
            </div>
          </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            form:{
                pageSize: 6,
                pageIndex: 1,
                modelitem:"NT01",
                newsmodel:"NewsType"
            },
            modelitemName:"公司动态",
            total:0,
            loopData0:[],
            FileAddress:"",
            telshow:false,
            // 移动端相关数据
            isMobile: false,
            mobileDisplayCount: 6,
            mobileInitialCount: 6,
            mobileCurrentPage: 1, // 移动端当前页码
            isLoadingMore: false, // 防止重复请求
        }
    },
    methods:{
       //当前页变化事件
        handleCurrentChange(val) {
                let that = this;
                that.form.pageIndex = val;
                that.getNewsCenterlist();
        },
        setState(state){
            let that = this;
            that.form.modelitem = state;
            if(state=='NT01'){
              that.modelitemName ="公司动态";
            }
            if(state=='NT02'){
              that.modelitemName ='媒体关注';
            }
            if(state=='NT03'){
              that.modelitemName ='行业新闻';
            }
            if(state=='NT04'){
              that.modelitemName ='影像先河';
            }
            // 重置移动端显示数量和页码
            that.mobileDisplayCount = that.mobileInitialCount;
            that.mobileCurrentPage = 1;
            that.form.pageIndex = 1;
            that.getNewsCenterlist();
        },
        getNewsCenterlist()
        {
          let that = this;
          // 移动端时增加pageSize以获取更多数据，前端控制显示数量
          let requestForm = { ...that.form };
          if (that.isMobile) {
            requestForm.pageSize = 50; // 移动端一次获取50条，前端分批显示
          }
          
          that.$api.post("/Client/getNewsCenterlist", requestForm,
              function (res) {
                  if (res.code === "200") {
                    that.loopData0 =[];
                    res.data.forEach(item=>{
                      that.loopData0.push({
                          id:item.id,
                          title:item.news_title,
                          subtitle:item.news_subtitle,
                          publishdate:item.publishdate,
                          is_open_attachment:item.is_open_attachment,
                          url:item.url,
                          is_open_url:item.is_open_url,
                          viewPath: (that.FileAddress + item.ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                          FilePath:(that.FileAddress + item.FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                        });
                    });
                      that.total = res.count;
                  }
              },
              function (res) {
                  that.$message.error("服务异常，信息出错");
              }
          );
        },
          selelctNews(item){
            var _this = this;
              if(item.is_open_attachment=='1'){
                 window.open(item.FilePath, '_blank');
              }else if(item.is_open_url=='1')
              {
                window.open(item.url, '_blank');
              }
              else{
                const { href } = this.$router.resolve({
                  path: "/Client/NewsDetails",
                  query: {
                    id:item.id,
                    modelitem:this.form.modelitem,
                    newsmodel:this.form.newsmodel
                  },
                });
                // 使用 window.open 在新窗口中打开该 URL
                window.open(href, '_self');

              }
          },
          handleMouseEnter(){
            let that = this;
            that.telshow = true;
          },
          handleMouseLeave(){
            let that = this;
            that.telshow = false;
          },
          // 移动端相关方法
          checkMobile() {
            this.isMobile = window.innerWidth <= 768;
          },
          loadMoreNews() {
            // 移动端加载更多新闻
            const allLoadedCount = this.loopData0.length; // 已加载的总数据量
            const willDisplayCount = this.mobileDisplayCount + this.mobileInitialCount; // 将要显示的数量
            
            // 如果将要显示的数量超过了已加载的数据，且服务器还有更多数据
            if (willDisplayCount >= allLoadedCount && allLoadedCount < this.total) {
              // 需要从服务器加载更多数据
              this.loadMoreNewsFromServer();
            } else {
              // 只增加显示数量（数据已经在本地）
              this.mobileDisplayCount += this.mobileInitialCount;
            }
          },
          loadMoreNewsFromServer() {
            // 从服务器加载下一页数据
            if (this.isLoadingMore) {
              return; // 防止重复请求
            }
            
            this.isLoadingMore = true;
            this.mobileCurrentPage += 1;
            
            let that = this;
            let requestForm = {
              pageSize: 50,
              pageIndex: that.mobileCurrentPage,
              modelitem: that.form.modelitem,
              newsmodel: that.form.newsmodel
            };
            
            that.$api.post("/Client/getNewsCenterlist", requestForm,
              function (res) {
                if (res.code === "200") {
                  // 将新数据追加到现有数组
                  res.data.forEach(item => {
                    that.loopData0.push({
                      id: item.id,
                      title: item.news_title,
                      subtitle: item.news_subtitle,
                      publishdate: item.publishdate,
                      is_open_attachment: item.is_open_attachment,
                      url: item.url,
                      is_open_url: item.is_open_url,
                      viewPath: (that.FileAddress + item.ViewFilePath.replace(" ", "%20").replace(/\\/g, '/')),
                      FilePath: (that.FileAddress + item.FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                    });
                  });
                  
                  // 增加显示数量
                  that.mobileDisplayCount += that.mobileInitialCount;
                  that.isLoadingMore = false;
                }
              },
              function (res) {
                that.$message.error("加载更多数据失败");
                that.isLoadingMore = false;
              }
            );
          },
          getMobileDisplayNews() {
            // 获取移动端应该显示的新闻列表
            return this.loopData0.slice(0, this.mobileDisplayCount);
          },
          hasMoreNews() {
            // 判断是否还有更多新闻（本地已加载 或 服务器还有）
            return this.mobileDisplayCount < this.loopData0.length || this.loopData0.length < this.total;
          },
          // 统一更新 modelitem 名称的方法
          updateModelitemName(type) {
            if (type === 'NT01') {
              this.modelitemName = "公司动态";
            } else if (type === 'NT02') {
              this.modelitemName = '媒体关注';
            } else if (type === 'NT03') {
              this.modelitemName = '行业新闻';
            } else if (type === 'NT04') {
              this.modelitemName = '影像先河';
            }
          },
    },
    mounted(){
      let that = this;
      
      // 先进行移动端检测，确保后续逻辑能正确判断
      that.checkMobile();
      window.addEventListener('resize', that.checkMobile);
      
      // 优先检查查询参数（用于移动端子菜单）
      if(this.$route.query.type!=null&&this.$route.query.type!=undefined)
      {
        that.form.modelitem = this.$route.query.type;
        that.updateModelitemName(this.$route.query.type);
      }
      // 然后检查路由参数（用于PC端）
      else if(this.$route.params.modelitem!=null&&this.$route.params.modelitem!=undefined)
      {
        that.form.modelitem = this.$route.params.modelitem;
        that.updateModelitemName(this.$route.params.modelitem);
      }
      // 如果都没有，使用默认值 NT01
      else {
        that.form.modelitem = 'NT01';
        that.modelitemName = '公司动态';
      }
      
      if(this.$route.params.newsmodel!=null&&this.$route.params.newsmodel!=undefined)
      {
        that.form.newsmodel = this.$route.params.newsmodel;
      }
      
      that.FileAddress = process.env.VUE_APP_FileAddress.replace('fileapi/', '');
      
      // 在检测完移动端后再获取数据
      that.getNewsCenterlist();
      
      // 移动端滚动到页面顶部
      if (that.isMobile) {
        that.$nextTick(() => {
          setTimeout(() => {
            // 滚动到移动端容器的位置
            const mobileContainer = document.querySelector('.mobile-news-container');
            if (mobileContainer) {
              mobileContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
            } else {
              // 备选方案：强制滚动到页面顶部
              window.scrollTo(0, 0);
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
            }
          }, 200);
        });
      }
    },
    beforeDestroy() {
      // 移除事件监听
      window.removeEventListener('resize', this.checkMobile);
    },
    watch:{
      '$route.query.type': {
        handler: function (newType, oldType) {
          // 监听路由查询参数变化（移动端子菜单切换）
          if (newType) {
            this.form.modelitem = newType;
            if (newType === 'NT01') {
              this.modelitemName = "公司动态";
            } else if (newType === 'NT02') {
              this.modelitemName = '媒体关注';
            } else if (newType === 'NT03') {
              this.modelitemName = '行业新闻';
            } else if (newType === 'NT04') {
              this.modelitemName = '影像先河';
            }
            // 重置移动端显示数量和页码
            this.mobileDisplayCount = this.mobileInitialCount;
            this.mobileCurrentPage = 1;
            this.form.pageIndex = 1;
            this.getNewsCenterlist();
            
            // 移动端滚动到页面顶部
            if (this.isMobile) {
              this.$nextTick(() => {
                setTimeout(() => {
                  // 滚动到移动端容器的位置
                  const mobileContainer = document.querySelector('.mobile-news-container');
                  if (mobileContainer) {
                    mobileContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
                  } else {
                    // 备选方案：强制滚动到页面顶部
                    window.scrollTo(0, 0);
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                  }
                }, 200);
              });
            }
          }
        }
      }
    }
}
</script>
<style scoped>
@import '../../../assets/client/newstrends.css';
@import '../../../assets/client/newstrends-mobile.css';
.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s;
}

.slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
  transform: translateX(10.53vw);
}
.p_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  animation: bannerimg 2s;
}

.p_info .p_btitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 59px;
  font-weight: 900;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p_info .p_subtitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 28px;
  font-weight: 400;
  position: relative;
  bottom: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.p_info {
  width: 100%;
  max-width: 1600px;
  padding: 0 5px;
  position: absolute;
  left: 257px;
  top: 120px;
  z-index: 9;
}

@keyframes puBanner {
  from {
    transform: translateY(200px);
    opacity: 0
  }

  to {
    transform: translateY(0);
    opacity: 1
  }
}

@keyframes bannerimg {
  from {
    transform: scale(1.15)
  }

  to {
    transform: scale(1);
  }
}
</style>
